import { create } from 'zustand';
import { ConnectionConfig } from '../types/types';
import { configApi } from '../lib/apiClient';

export  type ConnectionStatus ={
  id: string;
  status: string | 'unknown' | 'success' | 'error';
  url: string;
  name: string;
  env?: 'prod' | 'test' | 'dev';
}

interface ConnectionsState {
  connectors: ConnectionConfig[];
  connectorsLoading: boolean;
  connectionsStatus: ConnectionStatus[];
  isLoadingConnectors: boolean;
  getConnections: () => Promise<ConnectionConfig[]>;
  setConnectors: (connectors: ConnectionConfig[]) => void;
  setConnectorsLoading: (loading: boolean) => void;
  setConnectionStatus: (status: ConnectionStatus[]) => void;
  addConnectionStatus: (status: ConnectionStatus) => void;
  addConnection: (connection: ConnectionConfig) => void;
  updateConnection: (connection: ConnectionConfig) => void;
  removeConnection: (id: string) => void;
  getBasicConnectors:  () => void
}

export const useConnectionsStore = create<ConnectionsState>((set) => ({
  connectors: [],
  connectorsLoading: true,
  connectionsStatus: [],
  isLoadingConnectors: false,
  getConnections: async () => {
     set({ isLoadingConnectors: true });
     const connectors = await configApi.list();
     set({ isLoadingConnectors: false });
     return connectors;
  },
  setConnectors: (connectors) => set({ connectors, connectorsLoading: false }),
  setConnectorsLoading: (connectorsLoading) => set({ connectorsLoading }),
  setConnectionStatus: (status) => set({ connectionsStatus: status }),
  addConnectionStatus: (status) => set((state) => ({ connectionsStatus: [...state.connectionsStatus, status] })),
  addConnection: (connection) => set((state) => ({ connectors: [...state.connectors, connection] })),
  updateConnection: (connection) => set((state) => ({
    connectors: state.connectors.map(c => {
      if (c.id === connection.id) {
        return { ...c, ...connection };
      }
      return c;
    })
  })),
  removeConnection: (id) => set((state) => ({
    connectors: state.connectors.filter(c => c.id !== id)
  })),
  getBasicConnectors: async () => {
    const connectors = await configApi.getBasic();
    set({ connectors: connectors });
  }
}));